// eslint-disable-next-line
export const areCodesValid = (codes, errors) => codes.every((code) => errors.every((error) => code !== error));
